// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Container,
  Grid,
  Button,
  Message,
  Icon,
  Label,
  Segment,
  Placeholder,
  Card
} from 'semantic-ui-react'
import fire from '../config/Fire'

class Download extends Component {
  constructor (props) {
    super(props)
    this.state = {
      upload: null,
      loading: true,
      free: null,
      data: []
    }
  }

  componentDidMount = (event) => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        window.scrollTo(0, 0)
        const {
          match: { params }
        } = this.props
        this.setState({
          userEmail: user.email
        })
        this.premium()
      } else {
        this.props.history.push(`/`)
      }
    })
  }

  premium = (e) => {
    let { userEmail } = this.state
    this.setState({
      loading: true
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/premium/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: userEmail
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        this.setState({ done: true, loading: false, data: json })
        if (json.code === 200) {
          this.setState({ free: false })
        } else {
          this.setState({ free: true })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  render () {
    let { loading, error, data, free } = this.state
    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <h2>Download</h2>
        </div>

        <Grid reversed='mobile' centered stackable verticalAlign='top' fluid>
          <Grid.Column width='1' />
          <Grid.Column width='9'>
            {error ? (
              <Message compact negative>
                <p>Error: {error}</p>
              </Message>
            ) : null}

            <Grid columns='2' textAlign='left' stackable>
              <Grid.Column>
                {!loading ? (
                  <Segment fluid padded>
                    <div className='mbs'>
                      <div className='mbs'>
                        <Icon size='big' style={{ color: '#a4c639' }} name='android' />
                      </div>
                      <p>Android</p>
                    </div>
                    <Button
                      rel='noopener noreferrer'
                      target='_blank'
                      style={{ backgroundColor: '#E5E1DB', color: '#000' }}
                      disabled={!data.androidLink}
                      size='large'
                      href={data.androidLink}>
                      Download APK
                    </Button>
                  </Segment>
                ) : (
                  <Placeholder fluid>
                    <Placeholder.Image />
                  </Placeholder>
                )}
              </Grid.Column>
              <Grid.Column>
                {!loading ? (
                  <Segment fluid padded>
                    <div className='mbs'>
                      <div className='mbs'>
                        <Icon size='big' style={{ color: '#fecb2e' }} name='apple' />
                      </div>
                      <p>iOS</p>
                    </div>
                    <Button
                      rel='noopener noreferrer'
                      target='_blank'
                      style={{ backgroundColor: '#E5E1DB', color: '#000' }}
                      disabled={!data.iosLink}
                      size='large'
                      href={data.iosLink}>
                      Download IPA
                    </Button>
                  </Segment>
                ) : (
                  <Placeholder fluid>
                    <Placeholder.Image />
                  </Placeholder>
                )}
              </Grid.Column>
            </Grid>
            <Segment fluid padded textAlign='center'>
              {!loading ? (
                <div>
                  <Label style={{ backgroundColor: '#fff', color: '#000' }} size='huge'>
                    <Icon color='white' name='code' />
                    Source code
                  </Label>

                  <div className='mts'>
                    <Button
                      raised
                      rel='noopener noreferrer'
                      target='_blank'
                      style={{ backgroundColor: '#E5E1DB', color: '#000' }}
                      disabled={!data.sourceLink}
                      size='large'
                      href={data.sourceLink}>
                      View on BitBucket
                    </Button>
                  </div>
                </div>
              ) : (
                <Placeholder fluid>
                  <Placeholder.Paragraph>
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                  </Placeholder.Paragraph>
                </Placeholder>
              )}
            </Segment>
          </Grid.Column>

          <Grid.Column width='5'>
            {data.code === 200 && !loading && (
              <div className='mbs dashboard'>
                <h3 className='mb'>{data.user}</h3>
                <p>
                  <b>subscription_id:</b> {data.ID}
                </p>
                <p>
                  <b>next_payment:</b> {data.next}
                </p>
              </div>
            )}

            {data.code !== 200 && !loading && (
              <div className='center mbs dashboard'>
                <h3>{data.message}</h3>
                <Button href='/pricing' style={{ backgroundColor: '#000', color: '#eee' }}>
                  Upgrade
                </Button>
              </div>
            )}

            <div className='center dashboard'>
              {!loading && (
                <Button
                  fluid
                  disabled={free}
                  href='https://docs.google.com/forms/d/e/1FAIpQLSelo_I3aQnFVKljbn4RZXXFrQ4aQGMR0d8rK13r9S5z1hLu4A/viewform'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ backgroundColor: '#333', color: '#fff' }}>
                  <Icon name='code' />
                  Request Build
                </Button>
              )}
              <h4>
                Contact us if you have any question!
                <br />
                <a href='/contact' size='large'>
                  Get in touch.
                </a>
              </h4>
            </div>
          </Grid.Column>

          <Grid.Column width='1' />
        </Grid>
      </Container>
    )
  }
}

export default Download
